import { render, staticRenderFns } from "./AttachLessonsWithMultipleSessions.vue?vue&type=template&id=b1fbc3e4"
import script from "./AttachLessonsWithMultipleSessions.vue?vue&type=script&lang=js"
export * from "./AttachLessonsWithMultipleSessions.vue?vue&type=script&lang=js"
import style0 from "./AttachLessonsWithMultipleSessions.vue?vue&type=style&index=0&id=b1fbc3e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports